import axios from 'axios';
import staticHeaders from './staticHeaders.json';
import baseURL from "./baseURL";

export default (requestData) => new Promise((resolve) => {

  axios(`${baseURL()}/index.php?action=save_wallboard_no_login`, {
    method: "POST",
    headers: {
      ...staticHeaders,
      "Content-Type": "application/json"
    },
    data: requestData
      
  })
    .then(({ data }) => {
      if (data.result) {
        resolve(data);
      } else {
        resolve(data.message);
      }
    })
    .catch(err => {
      resolve(false);
    }); 

});